import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '../../redux/globals/globals.selectors';
import { motion } from 'framer-motion';
import './Driver.styles.scss';

const DriverUI = () => {
	const user = useSelector(selectUser);
	const [selectedKeyword, setSelectedKeyword] = useState();
	const timer = useRef();

	useEffect(() => {
		if (!user || !user.sentances || !user.sentances.length) return;

		let phrase = user?.sentances[Math.floor(Math.random() * user?.sentances?.length)];
		phrase = phrase.replace(':name', user.name);

		setSelectedKeyword({
			key: Math.random() * 10,
			phrase: phrase,
		});

		loop();

		return () => {
			clearTimeout(timer.current);
		};
	}, [user]);

	const loop = () => {
		if (!user?.sentances?.length) return;
		
		var rand = Math.round(Math.random() * (12000 - 5000)) + 5000;

		timer.current = setTimeout(() => {
			if (!user?.sentances?.length) return;
			
			let phrase = user.sentances[Math.floor(Math.random() * user.sentances.length)];
			phrase = phrase.replace(':name', user.name);

			setSelectedKeyword({
				key: Math.random() * 10,
				phrase: phrase,
			});
			loop();
		}, rand);
	};

	const wordAnimation = {
		hidden: {},
		visible: {},
	};

	return (
		<div className="driver-ui">
			{user && user.driver_image && (
				<>
					{selectedKeyword && (
						<div className="speech">
							<motion.div
								key={selectedKeyword.key}
								className="text"
								variants={wordAnimation}
								transition={{
									delayChildren: 0.25,
									staggerChildren: 0.05,
								}}
							>
								{selectedKeyword.phrase.split('').map((char, index) => {
									return (
										<motion.span
											key={index}
											initial={{ opacity: 0 }}
											animate={{ opacity: 1 }}
											transition={{
												delay: index * 0.05,
												staggerChildren: 0.05,
											}}
										>
											{char}
										</motion.span>
									);
								})}
							</motion.div>
						</div>
					)}
					<div className="avatar">
						<img src={user.driver_image} />
					</div>
				</>
			)}
		</div>
	);
};

export default DriverUI;
